import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledIconButton = styled(Ds.Button).attrs({
    appearance: "secondary",
})`
    // account for border width
    padding: 5px 5px;
    height: 2rem;
    width: 2rem;

    svg {
        width: 20px;
        height: 20px;
    }
`;
